import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { baseUrl } from '@fs/zion-config'
import { Link } from '@fs/zion-router'
import useForgotLink from '../hooks/useForgotLink'
import { LiteContext, RecoveryContext } from '../context'

export default function ForgotUsernamePasswordLink() {
  const { t } = useTranslation()
  const forgotLink = useForgotLink(true)
  const isLite = useContext(LiteContext)
  const isRecovery = useContext(RecoveryContext)

  // reset link does not need extra parameters since recovery session controls all this
  const forgotOrResetLink = isRecovery ? `${baseUrl}/identity/recovery/find-my-account/reset-password` : forgotLink

  return (
    !isLite &&
    (isRecovery ? (
      <Link id="forgot-password-link" to={forgotOrResetLink} wayfinding>
        {t('forgot-passwork.link', 'Forgot password')}
      </Link>
    ) : (
      <Link id="forgot-username-password-link" to={forgotOrResetLink} wayfinding>
        {t('forgot-username-passwork.link', 'Forgot username or password')}
      </Link>
    ))
  )
}
